'use client';

import { useContext } from 'react';

import { WizardContext } from './wizard-context';

// ----------------------------------------------------------------------

export const useWizardContext = () => {
  const context = useContext(WizardContext);

  if (!context)
    throw new Error(
      'useWizardContext context must be use inside WizardProvider',
    );

  return context;
};
